import { render } from "./DeviceDetailsAddMeterToRadio.vue?vue&type=template&id=48b3af52&scoped=true"
import script from "./DeviceDetailsAddMeterToRadio.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsAddMeterToRadio.vue?vue&type=script&lang=js"

import "./DeviceDetailsAddMeterToRadio.vue?vue&type=style&index=0&id=48b3af52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b3af52"]])

export default __exports__